module.exports = __webpack_public_path__ + "img/159131713376.47a296aa.png";